import { BrowserModule } from '@angular/platform-browser';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoaderComponent } from './components/loader/loader.component';

import { LoaderModule } from './components/loader/loader.module';
import { LoginModule } from './components/login/login.module';
import { AppBootstrapModule } from './app-bootstrap/app-bootstrap.module';
import { TermsandconditionsModule } from './components/termsandconditions/termsandconditions.module';
import { PrivacypolicyModule } from './components/privacypolicy/privacypolicy.module';
import { MedicaldisclaimerModule } from './components/medicaldisclaimer/medicaldisclaimer.module';
import { PasswordresetModule } from './components/passwordreset/passwordreset.module';
import { HttpClientModule } from '@angular/common/http';
import { HomeModule } from './components/home/home.module';
import { EnsureAuthenticated } from './services/ensure-authenticated.service';
import { LoginRedirect } from './services/login-redirect.service';
import { SharedModule } from '../app/shared/shared.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { Ng2DeviceDetectorModule } from 'ng2-device-detector';
import { MypathsModule } from './components/mypaths/mypaths.module';
import { EachpathModule } from './components/eachpath/eachpath.module';
import { OngoingModule } from './components/ongoing/ongoing.module';
import { EachExerciseModule } from './components/each-exercise/each-exercise.module';
import { HttpModule, Http, XHRBackend, RequestOptions } from '@angular/http';
import { HttpService } from './services/http.service';
import { httpFactory } from './services/http.factory';
import { LoaderService } from './services/loader.service';
import { MeditationModule } from './components/meditation/meditation.module';
import { ProfileModule } from './components/profile/profile.module';
import {RedirectModule} from './components/redirect/redirect.module'

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    AppBootstrapModule,
    AppRoutingModule,
    LoaderModule,
    LoginModule,
    MeditationModule,
    ProfileModule,    
    TermsandconditionsModule,
    PrivacypolicyModule,
    MedicaldisclaimerModule,
    PasswordresetModule,
    HomeModule,
    MypathsModule,
    EachpathModule,
    OngoingModule,
    EachExerciseModule,
    SharedModule,
    RedirectModule,
    PerfectScrollbarModule,
    Ng2DeviceDetectorModule.forRoot()
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [ EnsureAuthenticated,
    LoginRedirect,{
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: ''
    },
    {
      provide: HttpService,
      useFactory: httpFactory,
      deps: [XHRBackend, RequestOptions,LoaderService]
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/app.module.ts